var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesBubble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.03748 0 0 3.5873 0 7.99673C0.0309754 10.1425 0.940675 12.1635 2.48478 13.5169L0.684783 17.3887C0.610037 17.5494 0.637877 17.7435 0.754143 17.8723C0.870408 18.0012 1.04958 18.0364 1.20052 17.9601L6.01278 15.5444C6.98393 15.8452 7.98959 15.9967 9 15.9943C13.9625 15.9943 18 12.407 18 7.99673C18 3.58646 13.9625 0 9 0Z",
    fill: "#0088A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubble);
export default __webpack_public_path__ + "static/media/messages-bubble.40742231dd13621215a92c4f9fa4d9d2.svg";
export { ForwardRef as ReactComponent };